/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FileWorkflowSummary } from './fileWorkflowSummary';
import { FileWorkflowMyStep } from './fileWorkflowMyStep';


export interface MyDocumentItem { 
    fileId: string;
    originalName: string;
    mimeType: string;
    folderPath: string;
    /**
     * El archivo está en la rama de COVAS
     */
    isCova: boolean;
    /**
     * El archivo es del usuario (folder_files.user_id)
     */
    isOwner: boolean;
    access?: MyDocumentItem.AccessEnum;
    createdOn?: string;
    workflow?: FileWorkflowSummary;
    myStep?: FileWorkflowMyStep;
}
export namespace MyDocumentItem {
    export type AccessEnum = 'viewer' | 'editor';
    export const AccessEnum = {
        Viewer: 'viewer' as AccessEnum,
        Editor: 'editor' as AccessEnum
    };
}


